import ModuleModel from 'models/ModuleModel'

export default class ModulesCollection extends Backbone.Collection {

    get model() {
        return ModuleModel
    }

    get comparator() {
        return 'sequence'
    }

    initialize(data, options = {}) {
        const groupModel = options.groupModel
        if (groupModel) {
            for (const chapter of groupModel.chapters) {
                if (chapter.get('Module')) {
                    // Create module model for each unique model found in chapter data.
                    if (!this.has(chapter.get('Module').id)) {
                        const newModuleModel = new ModuleModel(
                            {
                                ...chapter.get('Module'),
                                groupId: groupModel.id,
                            },
                            {
                                groupModel,
                            }
                        )
                        this.push(newModuleModel)

                        Backbone.Collection.modules.push(newModuleModel)
                    }
                    chapter.set({moduleId: chapter.get('Module').id})
                    chapter.unset('Module', {silent: true})
                }
            }

            // Create "dummy" module that contains all chapters of this group
            // that don't belong to a module.
            // Only create this if the group contains a non-zero number
            // of modules.
            if (this.length) {
                this.push(new ModuleModel(
                    {
                        id: 0,
                        title: window.i18n.gettext('Other chapters'),
                        groupId: groupModel.id,
                    },
                    {
                        groupModel,
                    }
                ))

                // Set sequence on all module models.
                this.invoke('setSequence')
            }
        }
    }

}
